import { render, staticRenderFns } from "./MotorBikeRightFrontHeadLight.vue?vue&type=template&id=66d30ddb"
import script from "./MotorBikeRightFrontHeadLight.vue?vue&type=script&lang=js"
export * from "./MotorBikeRightFrontHeadLight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports